import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { usePlaceOrderMutation } from "../../../services/cartPageAPI";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import { useGetPaymentMOdesQuery } from "../../../services/commonAPI";
import { useEffect, useState } from "react";
const PayPalButton = ({ amount, formData, cartId }) => {
  const navigate = useNavigate();
  const [submitForm] = usePlaceOrderMutation();
  const { data: paymentmodes } = useGetPaymentMOdesQuery();
  const [decryptedPaypalKey, setDecryptedPaypalKey] = useState(null);
  const [isPaypalSdkReady, setIsPaypalSdkReady] = useState(false);

  const paypalMode = paymentmodes?.payment_modes?.find(
    (mode) => mode.name === "paypal"
  );
  const paypalPublicKey = paypalMode?.public_key || null;

  const decryptData = (encryptedData) => {
    try {
      console.log("encryptedData", encryptedData);

      if (!encryptedData) {
        console.error("Error: Encrypted data is null or empty!");
        return null;
      }

      const key = CryptoJS.enc.Hex.parse(
        process.env.REACT_APP_CRYPTOJS_AES_KEY
      );
      const iv = CryptoJS.enc.Hex.parse(process.env.REACT_APP_CRYPTOJS_AES_IV);

      if (!key || !iv) {
        console.error("Decryption key or IV is missing!");
        return null;
      }

      const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });

      const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

      if (!decryptedText) {
        console.error("Decryption failed: Empty result");
        return null;
      }

      console.log("Decrypted:", decryptedText);

      return JSON.parse(decryptedText);
    } catch (error) {
      console.error("Error decrypting data:", error);
      return null;
    }
  };

  const decryptedPaypalPublicKey = decryptData(paypalPublicKey);
  console.log("decryptedPaypalPublicKey", decryptedPaypalPublicKey);

  useEffect(() => {
    if (decryptedPaypalPublicKey) {
      setDecryptedPaypalKey(decryptedPaypalPublicKey);
      setIsPaypalSdkReady(true); // Mark PayPal SDK as ready
    }
  }, [decryptedPaypalPublicKey]);

  const handleSubmit = async (event, paymentDetails) => {
    event.preventDefault();

    const finalStreetAddress =
      `${formData.streetAddress1} ${formData.streetAddress2}`.trim();
    const finalDiffStreetAddress = formData.shipDifferent
      ? `${formData.shippingStreetAddress1} ${formData.shippingStreetAddress2}`.trim()
      : "";

    // Prepare the payload for the API
    const payload = {
      cart_id: cartId,
      payment_type: 1, // Since payment is done via PayPal
      first_name: formData.firstName,
      last_name: formData.lastName,
      company_name: formData.companyName,
      country: formData.country,
      street_address: finalStreetAddress,
      town_city: formData.city,
      state: formData.state,
      pin_code: formData.pinCode,
      phone: formData.phone,
      email: formData.email,
      account_create: formData.createAccount ? 1 : 0,
      diff_ship_address: formData.shipDifferent ? 1 : 0,
      order_notes: formData.orderNotes,
      paypal_order_id: paymentDetails.id, // Store PayPal Order ID
    };

    // Add shipping address fields if shipDifferent is true
    if (formData.shipDifferent) {
      Object.assign(payload, {
        ship_first_name: formData.shippingFirstName,
        ship_last_name: formData.shippingLastName,
        ship_company_name: formData.shippingCompanyName,
        ship_country: formData.shippingCountry,
        ship_street_address: finalDiffStreetAddress,
        ship_town_city: formData.shippingCity,
        ship_state: formData.shippingState,
        ship_pin_code: formData.shippingPinCode,
        ship_phone: formData.shippingPhone,
        ship_email: formData.shippingEmail,
      });
    }

    try {
      const response = await submitForm(payload).unwrap();
      localStorage.setItem("OrderId", response.order_id);
      localStorage.setItem("OrderMainId", response.order_main_id);

      navigate("/payment-success");
      // setTimeout(() => {
      //   navigate("/payment-success");
      // }, 2000);
    } catch (err) {
      console.error("Order submission error:", err);
    }
  };

  if (!isPaypalSdkReady) {
    return <div>Loading PayPal SDK...</div>; // Show a loading state until the SDK is ready
  }

  return (
    <PayPalScriptProvider options={{ "client-id": decryptedPaypalKey }}>
      <PayPalButtons
        style={{ layout: "vertical" }}
        createOrder={(data, actions) => {
          return actions.order.create({
            purchase_units: [
              {
                amount: {
                  value: amount,
                },
              },
            ],
          });
        }}
        onApprove={(data, actions) => {
          return actions.order.capture().then((details) => {
            handleSubmit(new Event("submit"), details); // Call handleSubmit on successful payment
          });
        }}
        onError={(err) => {
          console.error("PayPal Payment Error:", err);
        }}
      />
    </PayPalScriptProvider>
  );
};

export default PayPalButton;
